export const apikeyConstants = {
    APIKEY_GET_REQUEST: 'APIKEY_GET_REQUEST',
    APIKEY_GET_SUCCESS: 'APIKEY_GET_SUCCESS',
    APIKEY_GET_FAILURE: 'APIKEY_GET_FAILURE',

    APIKEY_GENERATE_REQUEST: 'APIKEY_GENERATE_REQUEST',
    APIKEY_GENERATE_SUCCESS: 'APIKEY_GENERATE_SUCCESS',
    APIKEY_GENERATE_FAILURE: 'APIKEY_GENERATE_FAILURE',

    APIKEY_REVOKE_REQUEST: 'APIKEY_REVOKE_REQUEST',
    APIKEY_REVOKE_SUCCESS: 'APIKEY_REVOKE_SUCCESS',
    APIKEY_REVOKE_FAILURE: 'APIKEY_REVOKE_FAILURE',

    APIKEY_CLEAR: 'APIKEY_CLEAR',
};
